import { Store, waitFor, _ } from 'utils';
import ResumeStore from './Resumes';
import RecommendationStore from './Recommendations';

class ActiveFilters extends Store {

	getInitialState() {
		return {
			filters: [],
			group: '',
			page: 0,
			count: 20
		};
	}

	uuid() {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
			var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
			return v.toString(16);
		});
	}

	onPageChanged(state) {
		waitFor([ResumeStore]);
		state.page = ResumeStore.getState().page;
	}

	onCountChanged(state) {
		waitFor([ResumeStore]);
		state.count = ResumeStore.getState().count;
	}

	onSelectSuggestion(state, data) {
		waitFor([RecommendationStore]);
		this.onAddFilter(state, {filter: RecommendationStore.getState().selected});
	}

	/*
	 * Collect data that will be sent to API
	 */
	collectFilters(data) {
		const {
			experience,
			qualifications,
			jobTypes,
			languages,
			driverLicensceTypes,
			managersExpiriences,
			languageFilter
		} = data;

		const filters = [];

		if(experience.min) {
			filters.push({
				src: 'experience',
				min: experience.min,
				description: _('Min ') + experience.min + _(' godina iskustva')
			});
		}

		if(experience.max > 0)
		{
			filters.push({
				src: 'experience',
				max: experience.max,
				description: _('Max ') + experience.max + _(' godina iskustva')
			});
		}
		else
        {
            if (experience.max == 0) {
                filters.push({
                    src: 'experience',
                    max: experience.max,
                    description: _('Nema radnog iskustva')
                });
            }
        }

		qualifications.forEach(function(item) {
			filters.push({
				src: 'qualification',
				key: item.key,
				description: item.name,
				selected: true
			});
		});
		languages.forEach(function(item) {
			if(languageFilter.length == 0){
				filters.push({
					src: 'language',
					sid: item.key,
					description: item.name,
				});
			}
		});
		languageFilter.forEach(function(item) {
			filters.push({
				src: 'languageFilter',
				key: item.src,
				description: item.description,
				active: item.active,
			});
		});
		jobTypes.forEach(item => {
			filters.push({
				src: 'job_types',
				key: item.key,
				description: item.name,
			});
		});

		driverLicensceTypes.forEach(item => {
			filters.push({
				src: 'driving_category',
				key: item.key,
				description: item.name,
			});
		});

		if (managersExpiriences) {
			filters.push({
				src: 'managerial_experience',
				key: managersExpiriences,
				description: 'Managersko iskustvo',
			});
		}

		return filters;
	}

	onApplyFilters(state, data) {

		const avoidFilters = [
			'experience', 'qualification', 'job_types', 
			'driving_category', 'managerial_experience',
			'languages','languageFilter'
		];

		const firstChunk = state.filters
			.filter(item => avoidFilters.includes(item.src) === false);

		const secondChunk = this.collectFilters(data);

		state.filters = [
			...firstChunk,
			...secondChunk,
		];
	}

	onAddFilter(state, data) {
		if(data.source){
			for(let i=0; i <= (Object.keys(data.filter).length -1); i++){
				if(data.filter[i].src == 'area'){
					var filter = { src: 'area', description: data.filter[i].description, sid: data.filter[i].sid };
					state.filters.push(filter);
				}
			}

		}else{
			if(data.filter.src == 'keyword') {
				var regex = /(?:"(.+?)"|(.+?))(?:\s|$)/g;
				var result = false;

				state.filters = [].concat(state.filters);

				while(result = regex.exec(data.filter.description)) {
					var keyword = result[1];

					if(keyword == undefined) {
						keyword = result[2];
					}

					var filter = { src: 'keyword', description: keyword };
					this.removeDuplicateFilter(state, filter);
					state.filters.push(filter);
				}
			} else {
				this.removeDuplicateFilter(state, data.filter);
				state.filters = [].concat(state.filters, [data.filter]);
			}
		}

		state.group = this.uuid();
		state.page = 0;
	}

	onClearFilters(state) {
		state.filters = [];
		state.page = 0;
	}

	removeDuplicateFilter(state, filter) {
		state.filters = state.filters.filter(function(item) {
			if(item.sid) {
				return !(item.sid === filter.sid && item.src === filter.src);
			} else {
				return !(item.src == filter.src && item.description == filter.description);
			}
		});

		state.page = 0;
	}

	onRemoveFilter(state, data) {
		this.removeDuplicateFilter(state, data.filter);
	}
}

const store = new ActiveFilters();
export default store;



// WEBPACK FOOTER //
// ./src/modules/model/ActiveFilters.js